<template>
	<div class="login-wrapper">
		<div class="container wrap1" style="height:350px">
			<div class="col-sm-8 col-md-5 center-auto pd-sm-50 pd-xs-20 main_content">
				<p class="text-center font18" style="color: #414141; font-weight: 600;">欢迎登录</p>
				<div class="tipbox" id="errormsg"></div>
				<form>
					<div class="form-group mg-t20">
						<i class="iconfont icon-shouji54 icon_font"></i>
						<input type="text" v-model="form.userName" class="login_input" placeholder="输入手机号（登录账号）"
							id="kefu_number" />
					</div>
					<div class="form-group mg-t20" v-if="loginType == 'sms_code'">
						<i class="iconfont icon-yanzhengma icon_font"></i>
						<input type="password" class="login_input" v-model="form.smsCode" placeholder="输入验证码" />
						<input class="btn btn-warning pull-right"
							style="display: inline;position: absolute;right: 9px;top: 7px;" type="button" value="获取验证码"
							@click="getSmsCode" />
					</div>
          <div class="form-group mg-t20" v-if="loginType == 'sms_code'">
            <i class="iconfont icon-yanzhengma icon_font"></i>
            <input type="text" class="login_input" v-model="form.google2faCode" placeholder="输入授权码" />
          </div>
					<div class="form-group mg-t20" v-if="loginType == 'password'">
						<i class="iconfont icon-mima icon_font"></i>
						<input type="password" v-model="form.password" class="login_input" placeholder="输入密码">
					</div>
					<button type="button" class="login_btn btn-warning" style="border: 1px solid orange;"
						@click="handleSubmit">登 录</button>
					<span v-if="loginType == 'password'&&!is_sms_code_login" @click="checkSmsCode"
						class="login_type">切换到验证码登录</span>
					<span v-if="loginType == 'sms_code'&&!is_sms_code_login" @click="checkPassword"
						class="login_type">切换到密码登录</span>
					<!--div>
						备案号：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备17117791号-2</a>
					</div-->
				</form>
			</div>
		</div>
	</div>

</template>
<script>
	import {
		mapActions
	} from 'vuex';
	import {
		getConfig,
		sendSms
	} from '@/api/api'
	export default {
		name: 'Login',
		data() {
			return {
				smsCode: '获取验证码',
				timer: null,
				countTime: 120,
				loginType: 'password',
				is_sms_code_login: false,
				form: {
					userName: '',
					password: '',
					smsCode: '',
          google2faCode: ''
				}
			}
		},
		mounted() {
			this.loadData();
		},
		methods: {
			...mapActions([
				'setTagNavList',
				'handleLogin',
				'getUserInfo',
				'handleConfig'
			]),
			async loadData() {
				let that = this;
				let res = await getConfig(that, {});
				if (res.code == 1) {
					that.handleConfig(res.data);
					this.is_sms_code_login = res.data.is_sms_code_login;
					if (this.is_sms_code_login) {
						this.loginType = 'sms_code';
					}
				}
			},
			getToken(){
				
			},
			handleSubmit() {
				let that = this;
				if (that.loginType == 'password') {
					that.form.smsCode = '';
				} else {
					that.form.password = '';
				}
				let userName = that.form.userName;
				let password = that.form.password;
				let smsCode = that.form.smsCode;
				let google2faCode = that.form.google2faCode;
				that.throttle(function() {
					that.handleLogin({
						userName,
						password,
						smsCode,
            google2faCode
					}).then(res => {
						if (res.code != 1) {
							that.$Message.warning(res.msg);
							return;
						}
						that.$Message.success(res.msg)
						that.getUserInfo().then(res => { 
							that.setTagNavList()
							if (res.code == 1) {
								that.$router.push({
									name: res.data.router
								})
							}
						})
					})
				}, 2000)
			},
			getSmsCode() {
				let that = this;
				if (this.form.userName == '') {
					this.$Message.error('请填写手机号');
					return false;
				}
				if (that.countTime != 120) {
					that.$Message.error('请勿手太快');
					return false;
				}
				this.throttle(async function() {
					let data = {
						phone: this.form.userName
					};
					let res = await sendSms(that, data);
					if (res.code == 1) {
						that.$Message.success('验证码已发送，请注意查收');
						that.countSms();
					}
				}, 500)
			},
			countSms() {
				let that = this;
				that.timer = setInterval(function() {
					if (that.countTime == 0) {
						that.countTime = 120;
						that.smsCode = '重新发送';
						clearInterval(that.timer);
						return;
					}
					that.countTime--;
					that.smsCode = that.countTime + 's';
				}, 1000)
			},
			checkSmsCode() {
				this.loginType = 'sms_code';
				this.form.smsCode = ''
			},
			checkPassword() {
				this.loginType = 'password';
				this.form.password = ''
			},
		}
	}
</script>
<style lang="less">
	.login-wrapper {
		
		position: relative;
		width: 100% ;
		height: 100%;
		background: url("../../assets/images/login-bg.jpg") #f5f7f9 ;
		background-size: cover;
		display: flex;
		flex-direction: column;
		overflow: auto;
	}


	.wrap1 {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto
	}

	.main_content {
		margin-left: auto;
		margin-right: auto;
		text-align: left;
		float: none;
		border-radius: 8px;
		background: #fff;
	}

	.form-group {
		position: relative;
	}

	.login_btn {
		display: block;
		color: #fff;
		font-size: 18px;
		width: 100%;
		line-height: 40px;
		border-radius: 3px;
		border: none;
		outline: none;
	}

	.login_input {
		color: #000;
		width: 100%;
		border: 1px solid #ccc;
		border-radius: 3px;
		line-height: 40px;
		padding: 2px 5px 2px 30px;
		outline: none;
	}

	.toptilte {
		margin-top: 5px;
		font-size: 22px;
	}

	.icon_font {
		position: absolute;
		bottom: 4px;
		left: 5px;
		font-size: 21px;
		color: #9E9E9E;
	}

	.font16 {
		font-size: 16px;
	}

	.mg-t20 {
		margin-top: 20px;
	}

	@media (min-width: 200px) {
		.pd-xs-20 {
			padding: 25px;
		}
	}

	@media (min-width: 992px) {
		.main_content {
			width: 40%;
		}
	}

	@media (min-width: 768px) {
		.pd-sm-50 {
			padding: 50px;
		}
	}

	.font18 {
		font-size: 22px;
	}

	.logo {
		width: 285px;
		height: 100px;
		margin-top: -5px;
		margin-left: 20px;
	}

	.logo img {
		margin-left: 60px;
		margin-top: 42px;
	}

	.fl {
		float: left;
	}

	.fr {
		float: right;
	}

	.ptxt {
		margin-left: 60px;
		margin-top: 50px;
	}

	.ptxt .em {
		margin-left: 50px;
		font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
	}

	.shu {
		width: 4px;
		height: 50px;
		background-color: #fff;
		margin-top: 43px;
	}

	.tipbox {
		color: red;
		text-align: center;
		background: #fff;
		padding: 3px 0;
		border-radius: 5px;
		position: absolute;
		left: 50%;
		top: 0;
		transform: translate(-50%, 15px)
	}

	a:hover {
		text-decoration: none;
		cursor: pointer;
	}
</style>
